export enum ResetDateType {
    both = 0,
    singleDate = 1,
    dateRange = 2
}
